import { RootState } from '@rb-serve-app/core';
import { useSelector } from 'react-redux';
import Button from './Button';
import { RightArrow } from '../assets/svg/ArrowIcon';
import { useNavigate } from 'react-router-dom';
import { EventType, useAnalytics } from '../ui/Analytics';

type ActiveRewardTileProps = {
  img: string;
  title: string;
  description: string;
  buttonText: string;
  customStyle: string;
  redirectTo?: string;
  onClick?: () => void;
  disabled?: boolean;
};

const ActiveRewardTile: React.FC<ActiveRewardTileProps> = ({
  img,
  title,
  description,
  buttonText,
  customStyle,
  redirectTo,
  onClick,
  disabled,
}) => {
  const { trackEvent } = useAnalytics();
  const { contentfulData } = useSelector(
    (state: RootState) => state.contentful
  );
  const { entries } = contentfulData;
  const { rb_rewards } = entries;
  const navigate = useNavigate();

  const trackClickEvent = (name: string) => {
    trackEvent(
      EventType.CLICK_EVENT,
      ['rewards landing page', 'rewards'],
      window.location.href,
      `rewards landing page | ${name}`
    );
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (redirectTo) {
      navigate(redirectTo);
      switch (redirectTo) {
        case '/view-rewards':
          trackClickEvent('cash back rewards');
          break;
        case '/redeem-rewards':
          trackClickEvent('earned rewards history');
          break;
        case '/world-legend-credit-redemption':
          trackClickEvent('rogers entertainment credit');
          break;
        default:
          console.log(`Unknown redirectTo value: ${redirectTo}`);
          break;
      }
    }
  };

  return (
    <div className={customStyle}>
      <div className="flex-shrink-0">
        <img
          src={img}
          alt={`Icon representing ${title}`}
          className="h-16 w-16"
        />
      </div>
      <div className="flex flex-col justify-center items-center md:block w-full">
        <div className="flex flex-col gap-1 lg:gap-1 xl:gap-[15px] md:gap-[15px] text-left xl:text-center lg:text-left md:text-center min-h-[140px] md:w-full w-[90%]">
          <h3
            aria-label={title}
            className="text-[16px] font-semibold text-[#1F1F1F]"
          >
            {title}
          </h3>
          <p
            aria-label={description}
            className="text-[16px] font-normal text-[#1F1F1F]"
          >
            {description}
          </p>
        </div>
        <div className="flex flex-col gap-2 w-full md:flex md:justify-center md:flex-row md:w-auto">
          <Button
            ariaLabel={buttonText}
            variant={'solid'}
            className={`text-sm font-medium py-2 px-4 ${disabled ? 'text-gray-400 bg-gray-100 border-gray-300 border-2' : 'bg-red-600 text-white'}`}
            onClick={handleClick}
          >
            {buttonText}
          </Button>
        </div>
        {/* <span
          className="view-text block md:hidden  w-[10%]"
          role="button"
          onClick={disabled ? undefined : handleClick}
        >
          <RightArrow width="24px" height="24px" />
        </span> */}
      </div>
    </div>
  );
};

export default ActiveRewardTile;
